// extracted by mini-css-extract-plugin
export var chartLegend = "cf_jj";
export var chartLegendContainer = "cf_jh";
export var colorBar = "cf_jm";
export var legendContent = "cf_jl";
export var legendItem = "cf_jk";
export var title = "cf_bH";
export var value = "cf_fP";